import React, { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";

// ✅ CONFIGURA WORKER DESDE CDN (unpkg soporta versiones recientes)
pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`;

const VisorPDF = ({ etiquetastoPrint }) => {
  const [fileUrl, setFileUrl] = useState(null);
  const [numPages, setNumPages] = useState(null);

  const visualizarEtiquetas = async () => {
    try {
      // const response = await EtiquetasService.generate(etiquetastoPrint);
      const blob = new Blob([etiquetastoPrint?.data], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      setFileUrl(url);
    } catch (error) {
      alert("Error al visualizar el PDF");
      console.error(error);
    }
  };

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  return (
    <div>
      <button onClick={visualizarEtiquetas}>Visualizar PDF</button>
      {fileUrl && (
        <div style={{ border: "1px solid #ccc", marginTop: 20 }}>
          <Document
            file={fileUrl}
            onLoadSuccess={onDocumentLoadSuccess}
            loading="Cargando PDF..."
          >
            {Array.from(new Array(numPages), (_, index) => (
              <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                width={600}
              />
            ))}
          </Document>
        </div>
      )}
    </div>
  );
};

export default VisorPDF;
